import { EcoaContent } from "@components/common/EconContent";
import { PreScreeningCover } from "@components/home/prescreening/PreScreeningCover";
import React, { useState } from "react";
import { FxGuard } from "@coralblack/flax/dist";
import { Footer } from "@layouts/Footer";
import { usePreScreeningSiteContext } from "@layouts/home/PreScreeningSiteContext";
import { Main } from "@layouts/Main";
import { ecoaConfigApi } from "maven-lib/dist/states/apis/ecoaConfig";
import { classNames } from "maven-lib/dist/utils/misc";
import { CrSection } from "@maven-surface/components/base/CrSection";
import { HbButton } from "@maven-surface/components/base/HbButton";
import { useRoute } from "@maven-surface/hooks/useRoute";
import { ECOA_CAPTURE_LANG } from "@maven-msg/lang/ecoaCapture";
import { MvnMessage } from "@maven-msg/lib/Message";

interface RecruitProps {
  studyId: bigint;
  siteId?: bigint;
}

export function Recruit(props: RecruitProps) {
  const { studyId } = props;
  const { selectedSite } = usePreScreeningSiteContext();
  const { pushPath } = useRoute();

  const [recruitCoverVisibility, setRecruitCoverVisibility] = useState<boolean>(true);

  return (
    <>
      {recruitCoverVisibility && <PreScreeningCover studyId={studyId} onStart={() => setRecruitCoverVisibility(false)} />}
      {!recruitCoverVisibility && selectedSite && (
        <Main header={{ appName: true }} footer={{ dummy: true }}>
          <FxGuard
            api={{
              ...ecoaConfigApi.getEcoaConfig(studyId),
              query: selectedSite
                ? {
                    site_id: selectedSite.id,
                  }
                : undefined,
            }}
            render={(resp) => {
              if (!resp?.config?.recruit) <></>;

              const recruit = resp?.config?.recruit;

              return (
                <>
                  <EcoaContent>
                    {!!recruit?.title && <span>{recruit?.title}</span>}
                    {recruit?.sections.map((section, sectionIdx) => (
                      <CrSection key={sectionIdx}>
                        {section.items.map((item, itemIdx) => (
                          <div key={itemIdx} className="app-ecoa-page-home-recruit-paragraph">
                            <dl>
                              <dt>{item.title}</dt>
                              {item.texts.map((text, textIdx) => (
                                <dd
                                  key={textIdx}
                                  className={classNames({
                                    "--unordered": item.texts.length > 1,
                                  })}
                                >
                                  {typeof text === "string" ? text : text.text}
                                </dd>
                              ))}
                            </dl>
                          </div>
                        ))}
                      </CrSection>
                    ))}
                  </EcoaContent>
                  <Footer>
                    <HbButton
                      onClick={() => {
                        pushPath(`/${studyId}/pre/${recruit?.nextStep || "privacy"}`);
                      }}
                      text={MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_PARTICIPATE)}
                    />
                  </Footer>
                </>
              );
            }}
          />
        </Main>
      )}
    </>
  );
}
